var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticStyle:{"padding":"0px"}},[_c('Home',{attrs:{"id":"home"}}),_c('About',{attrs:{"id":"about"}}),_c('v-parallax',{attrs:{"height":"300","src":require('@/assets/background/MIddle.png')}}),_c('Lawyer',{attrs:{"id":"lawyer"}}),_c('v-parallax',{attrs:{"height":"300","src":require('@/assets/background/Bottom.png')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }